import type { ReactElement } from 'react';
import { toast,Toaster as SonnerToaster } from 'sonner';

import { useAppSelector } from '@/app/store/hooks';
import { selectTheme } from '@/features/ui';

export function Toaster(): ReactElement {
  const theme = useAppSelector(selectTheme);

  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      theme={theme}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-soft-3',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
    />
  );
}

export { toast };
